const steps = [
  { threshold: 1_000_000_000, suffix: 'B' },
  { threshold: 1_000_000, suffix: 'M' },
  { threshold: 1_000, suffix: 'K' },
  { threshold: 1, suffix: '' },
]

export const humanizeNumber = (num: number | null | undefined, fallbackStr = '-'): string => {
  if (num === null || num === undefined || isNaN(num)) {
    return fallbackStr
  }
  const sign = num < 0 ? '-' : ''
  for (const step of steps) {
    if (Math.abs(num) >= step.threshold) {
      const majorNum = Math.floor(Math.abs(num) / step.threshold)
      const fractionPart = Math.round(Math.abs(num * 10) / step.threshold) % 10
      const fractionStr = fractionPart ? `.${fractionPart}` : ''
      return `${sign}${majorNum}${fractionStr}${step.suffix}`
    }
  }
  return `${sign}${num}`
}
